import React, { useState, useEffect } from 'react';
import Title from '../Title';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Blog_Section = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate(); // Hook for navigation

  const pageSlug = location.pathname.split('/').filter(Boolean).pop();
  const apiEndpoint = `https://blogs.vananiassociates.com/api/blogs/show/on/${pageSlug || 'home'}`;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const handleLinkClick = async (e, blogSlug) => {
    e.preventDefault(); // Prevent default navigation behavior

    try {
      const apiEndpoint = `https://blogs.vananiassociates.com/api/blogs/detail/${blogSlug}`;
      const response = await fetch(apiEndpoint);

      if (!response.ok) {
        throw new Error('Failed to fetch blog details');
      }

      const blogDetails = await response.json();
      // Navigate to the blog details page with the blogSlug
      navigate(`/blog/${blogSlug}`, { state: { blogDetails } });
    } catch (error) {
      console.error('Error fetching blog details:', error);
    }
  };

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(apiEndpoint);
        if (!response.ok) {
          throw new Error('Failed to fetch blogs');
        }
        const data = await response.json();
        setBlogs(data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [apiEndpoint]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!blogs.length) return <p>No blogs available</p>;

  return (
    <div className='blog_main_wrapper mt-5 mb-5 pt-2'>
      <div className='container'>
        <div className='section_main_title d-flex align-items-center justify-content-between'>
          <Title text="THE POPULAR BLOGS" className="custom-heading" />
          <ul className='d-flex align-items-center'>
            <li className='green'>fresh reads</li>
            <li className='orange'>quick insights</li>
            <li className='light-blue'>stay updated</li>
          </ul>
        </div>
        <div className='blog_list row we_serve'>
          <Slider {...settings}>
            {blogs.map((blog) => (
              <div key={blog.id} className="dynamic-item col-md-4 mt-0">
                <div className='blog_details_content'>
                  <Link
                    to={`/blog/${blog.slug}`}
                    className="text-decoration-none"
                    onClick={(e) => handleLinkClick(e, blog.slug)}
                  >
                    <div className='blob_img'>
                      <img className='img_width' src={blog.banner} alt='Blog Image' />
                    </div>
                    <div className='blog_content'>
                      <div className="d-flex w-100 justify-content-between">
                        <h5 className="mb-1">{blog.title}</h5>
                      </div>
                      <div className="mb-2" dangerouslySetInnerHTML={{ __html: blog.content.substring(0, 150).replace(/<\/p>$/, '...<\/p>'), }}></div>
                      <div className='inr_clm d-flex justify-content-between'>
                        <p className='date'><i className="far fa-clock"></i> {blog.created_at}</p>
                        <p className='name'><i className="far fa-user"></i> {blog.author}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </Slider>
          <div className='bottom_btn text-center mt-2'>
            <Link to="/Blogs" className='rounded-pill btn solid_btn'>
              View More Blog <i className="fas fa-chevron-right"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog_Section;
